define([], function() {
    return {
        POST: 'POST',
        PATH: 'PATH',
        QUERY: 'QUERY'
    };
});



// WEBPACK FOOTER //
// ./common/parameterApplications.js